import { AlertTriangle, Network, BookOpen, Eye, GitBranch, Workflow } from "lucide-react";

export const STANDARD_PROMPTS = [
  {
    id: "gap-check",
    label: "Gap & Completeness Check",
    icon: AlertTriangle,
    mode: "send",
    getText: () =>
      "Review this model for gaps: flag any orphaned elements with no relationships, layers that are thin or missing, and capabilities without a realizing element.",
  },
  {
    id: "dependency-hotspots",
    label: "Dependency Hotspots",
    icon: Network,
    mode: "send",
    getText: () =>
      "Which elements in this model have the most relationships connected to them, and could be risky single points of failure?",
  },
  {
    id: "architecture-briefing",
    label: "Architecture Briefing",
    icon: BookOpen,
    mode: "send",
    getText: () => "Give me a plain-English overview of this entire architecture, as if briefing someone new to the project.",
  },
  {
    id: "view-summary",
    label: "View Summary",
    icon: Eye,
    mode: "send",
    requiresView: true,
    getText: (viewName) => `Summarize what the view '${viewName}' represents, in plain English for a stakeholder who has never seen it.`,
  },
  {
    id: "impact-assessment",
    label: "Impact Assessment",
    icon: GitBranch,
    mode: "fill",
    getText: () => 'If I changed or removed "", what other elements and relationships would be affected?',
  },
  {
    id: "traceability-chain",
    label: "Traceability Chain",
    icon: Workflow,
    mode: "fill",
    getText: () => 'Show me everything that realizes, supports, or depends on "", tracing the full chain.',
  },
];

export function StandardPrompts({ currentView, onSend, onFill, disabled, className = "" }) {
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`} data-testid="standard-prompts-list">
      {STANDARD_PROMPTS.map((p) => {
        const isDisabled = disabled || (p.requiresView && !currentView);
        return (
          <button
            key={p.id}
            data-testid={`standard-prompt-${p.id}`}
            disabled={isDisabled}
            title={p.requiresView && !currentView ? "Open a view first" : undefined}
            onClick={() => (p.mode === "send" ? onSend(p.getText(currentView?.name)) : onFill(p.getText(currentView?.name)))}
            className="flex items-center gap-1.5 rounded-full border border-slate-700 bg-slate-800/60 px-2.5 py-1 text-[11px] text-slate-300 transition-colors hover:bg-slate-800 hover:text-white hover:border-purple-500/50 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-slate-800/60 disabled:hover:text-slate-300 disabled:hover:border-slate-700"
          >
            <p.icon size={11} />
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
